export default __webpack_public_path__ + "static/media/img-08.337eb98f.jpg";